// @i18n-ignore-file
import { CustomAttribute } from '@src/quince-site-common/src/domains/shopify/CustomAttribute'
import IShopifyCheckout, { IShopifyCheckoutLineItem } from '@src/quince-site-common/src/domains/shopify/ShopifyCheckout'
import { CheckoutLineItemInput } from '@src/quince-site-common/src/domains/shopify/ShopifyCheckoutLineItemInput'
import { createContext } from 'react'

import NewCheckoutService from '../NewCheckoutService'
import ShopifyCheckoutService from '../ShopifyCheckoutService'

export type CheckoutServiceType = NewCheckoutService | ShopifyCheckoutService
export type CheckoutServiceConstructor = typeof NewCheckoutService | typeof ShopifyCheckoutService

export interface CheckoutContextState {
  initialized: boolean
  CheckoutService: CheckoutServiceConstructor
  checkoutInstance: CheckoutServiceType
}

export const initialCheckoutContext: CheckoutContextState = {
  initialized: false,
  CheckoutService: {
    calculateDiscountForAllProdcut(_lineItem: IShopifyCheckoutLineItem): {
      price: number
      actualPrice: number
      discount: number
    } {
      throw new Error('calculateDiscountForAllProdcut must be called from within CheckoutContextProvider')
    },
    renderCustomAttributeCustomization(_customAttributes: CustomAttribute[]): string | undefined {
      throw new Error('renderCustomAttributeCustomization must be called from within CheckoutContextProvider')
    },
  },
  checkoutInstance: {
    getCheckoutId: () => {
      throw new Error('getCheckoutId must be called from within CheckoutContextProvider')
    },
    takeToCheckout: () => {
      throw new Error('takeToCheckout must be called from within CheckoutContextProvider')
    },
    handleShopifyDiscount: () => {
      throw new Error('handleShopifyDiscount must be called from within CheckoutContextProvider')
    },
    addDiscountToCheckout: (_discountCode: string) => {
      throw new Error('addDiscountToCheckout must be called from within CheckoutContextProvider')
    },
    initializeCheckout: () => {
      throw new Error('initializeCheckout must be called from within CheckoutContextProvider')
    },
    getCheckout(_?: boolean) {
      throw new Error('getCheckout must be called from within CheckoutContextProvider')
    },
    removeLineItem: (_: string) => {
      throw new Error('removeLineItem must be called from within CheckoutContextProvider')
    },
    removeLineItems: (_: string[]) => {
      throw new Error('removeLineItems must be called from within CheckoutContextProvider')
    },
    updateLineItem: (_lineItemId: string, _quantity: number) => {
      throw new Error('updateLineItem must be called from within CheckoutContextProvider')
    },
    addToCart: (
      _shopifyVariantId: number,
      _quantity = 1,
      _customAttributes: CustomAttribute[] = [],
    ): Promise<IShopifyCheckout> => {
      throw new Error('addToCart must be called from within CheckoutContextProvider')
    },
    addMultipleToCart: (
      _variantDetails: {
        shopifyVariantId: number
        quantity: number
        customAttributes: CustomAttribute[]
      }[],
    ): Promise<IShopifyCheckout> => {
      throw new Error('addMultipleToCart must be called from within CheckoutContextProvider')
    },
    getCartTotalItemsCount: (): Promise<number> => {
      throw new Error('getCartTotalItemsCount must be called from within CheckoutContextProvider')
    },
    updateCheckoutLineItem: (_lineItems: CheckoutLineItemInput[]): Promise<IShopifyCheckout> => {
      throw new Error('updateCheckoutLineItem must be called from within CheckoutContextProvider')
    },
  },
}

const CheckoutContext = createContext<CheckoutContextState>(initialCheckoutContext)

// @i18n-ignore
const CHECKOUT_CONTEXT_DISPLAY_NAME = 'Checkout Context'
CheckoutContext.displayName = CHECKOUT_CONTEXT_DISPLAY_NAME

export default CheckoutContext
